import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, switchMap, take } from 'rxjs';

import { MilestonesApiOperation, selectMilestonesUrl } from '../app-entities/feature-flag/milestones-api-url.selectors';
import { RocksApiOperation, selectRocksUrl } from '../app-entities/feature-flag/rocks-api-url.selectors';

import { FollowersEntityType } from './followers.model';

@Injectable({
  providedIn: 'root',
})
export class FollowersService {
  private readonly baseUrl = '/api/v4';

  private readonly http = inject(HttpClient);
  private readonly store = inject(Store);
  private readonly milestones = 'Milestones';
  private readonly rocks = 'Rocks';

  getFollowers(entityType: FollowersEntityType, entityId: string): Observable<string[]> {
    // Temporary handling for Milestones until fully migrated to microservice
    if (entityType === this.milestones) {
      return this.selectMilestonesUrl('followers').pipe(
        switchMap(url => this.http.get<string[]>(`${url}/${entityId}/followers`))
      );
    }
    if (entityType === this.rocks) {
      return this.selectRocksUrl('followers').pipe(
        switchMap(url => this.http.get<string[]>(`${url}/${entityId}/followers`))
      );
    }
    return this.http.get<string[]>(`${this.baseUrl}/${entityType}/${entityId}/followers`);
  }

  addFollowers(entityType: FollowersEntityType, entityId: string, followerIds: string[]): Observable<string[]> {
    // Temporary handling for Milestones until fully migrated to microservice
    if (entityType === this.milestones) {
      return this.selectMilestonesUrl('followers').pipe(
        switchMap(url => this.http.post<string[]>(`${url}/${entityId}/followers`, { userIds: followerIds }))
      );
    }
    if (entityType === this.rocks) {
      return this.selectRocksUrl('followers').pipe(
        switchMap(url => this.http.post<string[]>(`${url}/${entityId}/followers`, { userIds: followerIds }))
      );
    }
    return this.http.post<string[]>(`${this.baseUrl}/${entityType}/${entityId}/followers`, { userIds: followerIds });
  }

  removeFollower(entityType: FollowersEntityType, entityId: string, userId: string): Observable<string[]> {
    // Temporary handling for Milestones until fully migrated to microservice
    if (entityType === this.milestones) {
      return this.selectMilestonesUrl('followers').pipe(
        switchMap(url => this.http.delete<string[]>(`${url}/${entityId}/followers/${userId}`))
      );
    }
    if (entityType === this.rocks) {
      return this.selectRocksUrl('followers').pipe(
        switchMap(url => this.http.delete<string[]>(`${url}/${entityId}/followers/${userId}`))
      );
    }
    return this.http.delete<string[]>(`${this.baseUrl}/${entityType}/${entityId}/followers/${userId}`);
  }

  private selectMilestonesUrl(operation: MilestonesApiOperation): Observable<string> {
    return this.store.select(selectMilestonesUrl(operation)).pipe(take(1));
  }

  private selectRocksUrl(operation: RocksApiOperation): Observable<string> {
    return this.store.select(selectRocksUrl(operation)).pipe(take(1));
  }
}
